import affiliateCardQuiz from '../views/affiliatecard/quiz/affiliateCardQuiz'

export default [
  {
    path : '/old/affiliate/card-quiz-event',
    name :'affiliate',
    component : affiliateCardQuiz
  },
]


// WEBPACK FOOTER //
// ./src/router/cardquiz.js